
import { i18nText } from '@/locales';
import { RouterNameEnum } from "@/router/router.types";
export const ServicesRoutes = [
    {
        path: "/services",
        redirect: "/services/index",
        component: (): any => import("@/UI/layouts/MainLayout.vue"),
        meta: {
            alias: RouterNameEnum.Services,
            auth: true,
        },
        children: [
            {
                path: "/services/:Studio",
                meta: {
                    alias: RouterNameEnum.Services,
                    title: i18nText("Услуги - EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Услуги") }
                    ],
                    props: {
                        source: {
                            root: "servicesCategoryNomenclature",
                            name: "servicesCategoryNomenclature",
                            items: "items",
                            item: "item",
                            routePage: RouterNameEnum.ServicesPage,
                        },
                        mode: 0,
                    },
                },
                name: RouterNameEnum.Services,
                component: (): any => import("@/UI/pages/services/ServiceIndex.vue"),
            },
            {
                path: "/services/:Studio/page/:page/:pageSize/:total/:filter",
                meta: {
                    alias: RouterNameEnum.Services,
                    title: i18nText("Услуги - EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Услуги") }
                    ],
                    props: {
                        source: {
                            root: "servicesCategoryNomenclature",
                            name: "servicesCategoryNomenclature",
                            items: "items",
                            item: "item",
                            routePage: RouterNameEnum.ServicesPage,
                        },
                        mode: 0,
                    },
                },
                name: RouterNameEnum.ServicesPage,
                component: (): any => import("@/UI/pages/services/ServiceIndex.vue"),

            },

            {
                path: "/partner/:Studio",
                meta: {
                    alias: RouterNameEnum.Services,
                    title: i18nText("Услуги - EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Услуги партнеров"), support: ["studioselect"] }
                    ],
                    props: {
                        source: {
                            root: "servicesCategory",
                            name: "servicesCategory",
                            items: "serviceCategory",
                            item: "serviceCategory",
                            routePage: RouterNameEnum.PartnerServicesPage,
                        },
                        mode: 1,
                    },
                },
                props: {
                    source: {
                        root: "servicesCategory",
                        name: "servicesCategory",
                        items: "serviceCategory",
                        item: "serviceCategory",
                        routePage: RouterNameEnum.PartnerServicesPage,
                    },
                    mode: 1,
                },
                name: RouterNameEnum.PartnerServices,
                component: (): any => import("@/UI/pages/services/ServicePartner.vue"),

            },
            {
                path: "/partner/:Studio/page/:page/:page_size/:total/:filter",
                meta: {
                    alias: RouterNameEnum.Services,
                    title: i18nText("Услуги - EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Услуги партнеров"), support: ["studioselect"] }
                    ],
                    props: {
                        source: {
                            root: "servicesCategory",
                            name: "servicesCategory",
                            items: "serviceCategory",
                            item: "serviceCategory",
                            routePage: RouterNameEnum.PartnerServicesPage,
                        },
                        mode: 1,
                    },
                },
                name: RouterNameEnum.PartnerServicesPage,
                component: (): any => import("@/UI/pages/services/ServicePartner.vue"),
                props: {
                    source: {
                        root: "servicesCategory",
                        name: "servicesCategory",
                        items: "serviceCategory",
                        item: "serviceCategory",
                        routePage: RouterNameEnum.PartnerServicesPage,
                    },
                    mode: 1,
                },
            },
            {
                path: "/services/creation/:category_id",
                name: RouterNameEnum.ServicesCreation,
                meta: {
                    alias: RouterNameEnum.Services,
                    title: i18nText("Создание услуг - EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Услуги") , link: "Services" },
                        { name: i18nText("Создание услуги")}
                    ]
                },
                component: (): any => import("@/UI/pages/services/ServiceCreation.vue"),
                children: [
                    {
                        path: "cosmetologist",
                        name: RouterNameEnum.ServicesCreationCosmetologists,
                        meta: {
                            alias: RouterNameEnum.Services,
                        },
                        component: (): any =>
                            import("@/UI/components/forms/serviceCreate/ServiceCosmetologistLayout.vue"),
                    },
                    {
                        path: "consumables",
                        name: RouterNameEnum.ServicesCreationConsumables,
                        meta: {
                            alias: RouterNameEnum.Services,
                        },
                        component: (): any =>
                            import("@/UI/components/forms/serviceCreate/ServiceConsumablesLayout.vue"),
                    },
                    {
                        path: "documents",
                        name: RouterNameEnum.ServicesCreationDocuments,
                        meta: {
                            alias: RouterNameEnum.Services,
                        },
                        component: (): any => import("@/UI/components/forms/serviceCreate/ServiceDocumentsLayout.vue"),
                    },
                    {
                        path: "anamnez",
                        name: RouterNameEnum.ServicesCreationAnamnez,
                        meta: {
                            alias: RouterNameEnum.Services,
                        },
                        component: (): any => import("@/UI/components/forms/serviceCreate/ServiceAnamnezLayout.vue"),
                    },
                    {
                        path: "algoritm",
                        name: RouterNameEnum.ServicesCreationAlgoritm,
                        meta: {
                            alias: RouterNameEnum.Services,
                        },
                        component: (): any => import("@/UI/components/forms/serviceCreate/ServiceAlgoritmLayout.vue"),
                    },
                ],
            },
            {
                path: "/service_update/:id",
                name: RouterNameEnum.ServiceUpdate,
                meta: {
                    alias: RouterNameEnum.Services,
                    title: i18nText("Редактирование услуги - EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Услуги"), link: "Services" },
                        { name: i18nText("Детальная страница"), link: "ServiceDetail" },
                        { name: i18nText("Редактирование услуги") }
                    ],
                },
                component: (): any => import("@/UI/pages/services/ServiceUpdate.vue"),
            },
            {
                path: "/partner_update/:id",
                name: RouterNameEnum.PartnerServiceUpdate,
                meta: {
                    alias: RouterNameEnum.Services,
                    title: i18nText("Редактирование услуги - EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Услуги партнеров"), link: "PartnerServices" },
                        { name: i18nText("Детальная страница"), link: "ServiceDetailWorkers" },
                        { name: i18nText("Редактирование услуги партнера") }
                    ],
                },
                component: (): any => import("@/UI/pages/services/PartnerServiceUpdate.vue"),
            },
            {
                path: "/service/:id",
                name: RouterNameEnum.ServiceDetail,
                meta: {
                    alias: RouterNameEnum.Services,
                    title: "",
                    breadcrumb: [
                        { name: i18nText("Услуги"), link: "Services" },
                        { name: i18nText("Детальная страница") }
                    ],
                },
                component: (): any => import("@/UI/pages/services/ServiceDetail.vue"),
            },
            {
                path: "/partner/service/:id",
                redirect: "/partner/service/:id/workers",
                name: RouterNameEnum.ServicePartnerDetail,
                meta: {
                    alias: RouterNameEnum.Services,
                    title: "",
                },
                component: (): any => import("@/UI/pages/services/ServicePartnerDetail.vue"),
                children: [
                    {
                        path: "workers",
                        name: RouterNameEnum.ServiceDetailWorkers,
                        meta: {
                            alias: RouterNameEnum.Services,
                            title: "",
                            breadcrumb: [
                                { name: i18nText("Услуги партнеров"), link: "PartnerServices" },
                                { name: i18nText("Детальная страница") }
                            ],
                        },
                        component: (): any => import("@/UI/components/services/ServiceWorkers.vue"),
                    },
                    {
                        path: "products",
                        name: RouterNameEnum.ServiceDetailProducts,
                        meta: {
                            alias: RouterNameEnum.Services,
                            title: "",
                            breadcrumb: [
                                { name: i18nText("Услуги партнеров"), link: "PartnerServices" },
                                { name: i18nText("Детальная страница") }
                            ],
                        },
                        component: (): any => import("@/UI/components/services/ServiceProducts.vue"),
                    },
                    {
                        path: "documents",
                        name: RouterNameEnum.ServiceDetailDocuments,
                        meta: {
                            alias: RouterNameEnum.Services,
                            title: "",
                            breadcrumb: [
                                { name: i18nText("Услуги партнеров"), link: "PartnerServices" },
                                { name: i18nText("Детальная страница") }
                            ],
                        },
                        component: (): any => import("@/UI/components/services/ServiceDocuments.vue"),
                    },
                    {
                        path: "anamnez",
                        name: RouterNameEnum.ServiceDetailAnamnez,
                        meta: {
                            alias: RouterNameEnum.Services,
                            title: "",
                            breadcrumb: [
                                { name: i18nText("Услуги партнеров"), link: "PartnerServices" },
                                { name: i18nText("Детальная страница") }
                            ],
                        },
                        component: (): any => import("@/UI/components/services/ServiceAnamnez.vue"),
                    },
                ],
            },
        ],
    },
];
